import { cn } from "@/lib/utils";

interface BadgeProps {
  children: React.ReactNode;
  showDot?: boolean;
  className?: string;
}

export const Badge = ({ children, showDot = true, className }: BadgeProps) => {
  return (
    <div className={cn("badge-status", className)}>
      {showDot && <span className="badge-dot animate-pulse-glow" />}
      {children}
    </div>
  );
};

interface TagProps {
  children: React.ReactNode;
  className?: string;
}

export const Tag = ({ children, className }: TagProps) => {
  return (
    <div className={cn("tag", className)}>
      <span className="tag-dot" />
      {children}
    </div>
  );
};
